<ng-container *ngIf="praticaProgressService.isFrozen">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <a mat-tab-link *ngFor="let link of links" [active]="routerLinkActive.isActive" [routerLink]="[link]"
      #routerLinkActive="routerLinkActive" routerLinkActive> {{link | label}} </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <div style="padding-top: 48px;">
      <router-outlet></router-outlet>
    </div>
  </mat-tab-nav-panel>
</ng-container>

<router-outlet *ngIf="!praticaProgressService.isFrozen"></router-outlet>
